import classnames from 'classnames';
import { CKBox, CKContainerProps, CKSkeleton, CKSkeletonProps } from 'clearkit';
import React, { FC } from 'react';

type SettingsCardProps = CKContainerProps;
type SettingsCardSkeletonProps = CKSkeletonProps;

type SettingsCardComposition = {
  Body: FC<CKContainerProps>;
  Header: FC<CKContainerProps>;
  Heading: FC<CKContainerProps>;
  Footer: FC<CKContainerProps>;
};

const boxSize = 'max-w-4xl';

export const SettingsCardSkeleton: FC<SettingsCardSkeletonProps> = ({
  className,
  children,
  isLoading = true,
  ...rest
}) => (
  <CKSkeleton
    className={classnames(boxSize, className)}
    isLoading={isLoading}
    {...rest}
  >
    {children}
  </CKSkeleton>
);

export const SettingsCard: FC<SettingsCardProps> & SettingsCardComposition = ({
  className,
  children,
  ...rest
}) => (
  <CKBox className={classnames(boxSize, className)} {...rest}>
    {children}
  </CKBox>
);

SettingsCard.Body = ({ className, ...rest }) => (
  <div className={classnames('px-8 p-6', className)} {...rest} />
);
SettingsCard.Body.displayName = 'SettingsCard.Body';

SettingsCard.Footer = ({ className, ...rest }) => (
  <footer
    className={classnames(
      'px-8 py-4 last:pb-8 border-t border-gray-200',
      className,
    )}
    {...rest}
  />
);
SettingsCard.Footer.displayName = 'SettingsCard.Footer';

SettingsCard.Header = ({ className, ...rest }) => (
  <header className={classnames('p-8 pb-0', className)} {...rest} />
);
SettingsCard.Header.displayName = 'SettingsCard.Header';

SettingsCard.Heading = ({ children, className, ...rest }) => (
  <h2
    className={classnames('font-medium text-[1.325rem] mb-1', className)}
    {...rest}
  >
    {children}
  </h2>
);
SettingsCard.Heading.displayName = 'SettingsCard.Heading';
